const MyInformationComponent = () => import('@/views/user/MyInformationView')

export default [
    {
        path:'/MyInformation',
        name:'MyInformationComponent',
        component:MyInformationComponent
    }
]